import React from 'react';
import PropTypes from 'prop-types';
import PlayerCompareStatsRow from './playerComapreStatsRow.jsx';
import Select2 from 'react-select2-wrapper';
import {store} from '../football_stats.jsx';

function playerChanged(e) {
    if(e.type == 'change' && e.currentTarget.value != "") {
        let side = e.delegateTarget.id == 'comparePlayer1Select' ? 1 : 2;
        let type = typeof jQuery(e.currentTarget).data()['widgettype'] != 'undefined' ? jQuery(e.currentTarget).data()['widgettype'] : 'player';
        store.dispatch({type: 'CHANGE_PLAYER', widgettype: type, playerId: e.currentTarget.value, side: side});
    }
}

const PlayerCompareWidget = ({
    stats,
    players,
    player1Id,
    player2Id,
    type = "player",
    scrollClassName,
    compareCategories = categories
}) =>  {
    let selectOptions = {
        width: '100%'
    };
    let select2Options = {
        width: '100%'
    };

    if(type == 'team') {
        compareCategories = teamCategories;
    }

    let lockCurrentPlayer = currentSitePage == 'player';
    let player1ImageUrl = "";
    let player2ImageUrl = "";

    // let seasonNumber = 32; //Old instat season number
    let seasonNumber = 436;

    let teamImageId = getObjField(players[player1Id], 'teamInstatId');
    let playerImageId = getObjField(players[player1Id], 'instatId');

    let team2ImageId = getObjField(players[player2Id], 'teamInstatId');
    let player2ImageId = getObjField(players[player2Id], 'instatId');

    if(seasonNumber >= 32) {
        teamImageId = getObjField(players[player1Id], 'teamId');
        playerImageId = getObjField(players[player1Id], 'id');

        if(typeof teamImageId == 'object') {
            teamImageId = teamImageId.id;
        }

        team2ImageId = getObjField(players[player2Id], 'teamId');
        player2ImageId = getObjField(players[player2Id], 'id');

        if(typeof team2ImageId == 'object') {
            team2ImageId = team2ImageId.id;
        }
    }

    if(typeof players[player1Id] == 'undefined') {
        selectOptions.placeholder= getByLang('Search Player','חפש שחקן', 'ابحث عن لاعب');
    } else {
        //Change season number every season
        player1ImageUrl = "https://static.football.co.il/wp-content/themes/kingclub-theme/images/players/" + seasonNumber + "-" + teamImageId + "-" + playerImageId + ".png";
    }

    if(typeof players[player2Id] == 'undefined') {
        select2Options.placeholder= getByLang('Search Player','חפש שחקן', 'ابحث عن لاعب');
    } else {
        //Change season number every season
        player2ImageUrl = "https://static.football.co.il/wp-content/themes/kingclub-theme/images/players/" + seasonNumber + "-" + team2ImageId + "-" + player2ImageId + ".png";
    }

    let playersSelect = Object.keys(players).length ? Object.keys(players).map(function (key) {
        return {value: players[key].id, text: getObjField(players[key]), id: players[key].id}
    }) : [];

        let headerTitle = getByLang('One on One', 'ראש בראש', 'راس برأس');
        let playerImage2 = (type == 'player') ?
            player2ImageUrl :
            "https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + player2Id + ".png";

        let playerImage1 =
            (type == 'player') ?
                player1ImageUrl :
                "https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + player1Id + ".png";

    let player1Stat = "";
    let player2Stat = "";

    if(typeof players[player1Id] != 'undefined' && typeof players[player2Id] != 'undefined') {
        let player1Statskey = '902_26/27_totalStage_0_0_' + players[player1Id].teamId + '_' + player1Id;
        player1Stat = stats[player1Statskey];

        let player2Statskey = '902_26/27_totalStage_0_0_' + players[player2Id].teamId + '_' + player2Id;
        player2Stat = stats[player2Statskey];
    }

    return (<div className="compare-table col-xs-12">
            <div className="compare-row col-xs-12" id="compare-header">{ headerTitle }</div>
            <div className="player-compare-selection col-xs-12">
                <div className="player-compare-container col-xs-5 no-padding">
                    <div id="currentPlayerImage"
                         className="player-compare-image lazy"
                         style={{ backgroundImage: (type == 'player') ?
                                 "url(" + player1ImageUrl + ")" :
                                 "url(https://static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + player1Id + ".png)"}}
                         data-src={playerImage1}
                         data-bg={playerImage1}
                    />
                    <Select2 id="comparePlayer1Select"
                             value={ player1Id != null ? player1Id: null}
                             onChange={playerChanged}
                             data={ lockCurrentPlayer ? [{value: player1Id,
                                                          text: typeof players[player1Id] != 'undefined' ? getObjField(players[player1Id]) : '',
                                                          id: player1Id }] : playersSelect}
                             options={selectOptions}
                             data-widgettype={type}
                    />
                </div>
                <div className="text-blue inline-block player-compare-vs-label col-xs-2 no-padding" id="vs"></div>
                <div className="player-compare-container col-xs-5 no-padding">
                    <div id="playerCompareImage"
                         data-src={playerImage2}
                         data-bg={playerImage2}
                         style={{backgroundImage:
                                 (type == 'player') ?
                                     "url(" + player2ImageUrl  + ")" :
                                     "url(//static.football.co.il/wp-content/themes/kingclub-theme/images/teams/" + player2Id + ".png)" }}
                         className="player-compare-image col-xs-12 lazy"
                    />
                    <Select2 id="comparePlayer2Select"
                             value={ player2Id != null ? player2Id: null}
                             data={playersSelect}
                             onChange={playerChanged}
                             options={select2Options}
                             data-widgettype={type}
                    />
                </div>
            </div>
            <div className={ scrollClassName } >

                {compareCategories.map(cat =>
                    <PlayerCompareStatsRow
                        key={cat.name}
                        statsField={getObjField(cat)}
                        player1Stat={
                            typeof players[player1Id] != 'undefined' && player1Stat != null &&
                                player1Stat[cat.field] != 'undefined' ?
                                player1Stat[cat.field].toFixed(player1Stat[cat.field] % 1 === 0 ? 0 : 2) : "-"}
                        player2Stat={
                             typeof players[player2Id] != 'undefined' && player2Stat != null &&
                             player2Stat[cat.field] != 'undefined' ?
                             player2Stat[cat.field].toFixed(player2Stat[cat.field] % 1 === 0 ? 0 : 2) : "-"} />
                    )}
            </div>
        </div>
    )
};


PlayerCompareWidget.propTypes = {
    players: PropTypes.any.isRequired,
    player1Id: PropTypes.any.isRequired,
    player2Id: PropTypes.any.isRequired,
    scrollClassName: PropTypes.string.isRequired
};

export default PlayerCompareWidget;
